export default (form: HTMLFormElement) => {
    const recaptcha = form.querySelector(".g-recaptcha");
    const check = () => {
        if (recaptcha) {
            // @ts-ignore
            if (window["___grecaptcha_cfg"]) {
                form.classList.remove("form-disabled");
            } else {
                form.classList.add("form-disabled");
                const disabledMessage = document.createElement("a");
                disabledMessage.classList.add("form-disabled-msg");
                disabledMessage.innerText = "Wir nutzen den Drittanbieter reCAPTCHA zur Prüfung Ihrer Eingabe. Dieser kann persönliche Daten über Ihre Aktivitäten sammeln. Bitte beachten Sie die weiteren Informationen und geben Sie Ihre Einwilligung. Bitte laden Sie anschließend die Seite neu.";
                disabledMessage.onclick = () => {
                    // @ts-ignore
                    usercentrics.toggleConsentInfoModalIsVisible('Hko_qNsui-Q');
                    return false;
                };
                form.appendChild(disabledMessage);
            }
        }
    };
    check();
};